var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSocialOutlineFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.757 7.757A6 6 0 0119 6h3a1 1 0 011 1v4a1 1 0 01-1 1h-3v1h3a1 1 0 01.97 1.242l-1 4A1 1 0 0121 19h-2v6a1 1 0 01-1 1h-4a1 1 0 01-1-1v-6h-2a1 1 0 01-1-1v-4a1 1 0 011-1h2v-1a6 6 0 011.757-4.243zM19 8a4 4 0 00-4 4v2a1 1 0 01-1 1h-2v2h2a1 1 0 011 1v6h2v-6a1 1 0 011-1h2.22l.5-2H18a1 1 0 01-1-1v-2a2 2 0 012-2h2V8h-2z",
    fill: "#000"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-social-outline--Facebook-fe722e0ce7d150e391977d21feb53e6a.svg";
export { SvgIconSocialOutlineFacebook as Component };